const ACCESS_TOKEN_KEY = "access_token"

export type AuthTokenClaims = {
  sub?: string
  email?: string | null
  is_active?: boolean
  roles?: string[]
  client_provider_client_id?: string | null
  client_provider_id?: string | null
  exp?: number
  iat?: number
}

const parseBase64Url = (value: string): string | null => {
  try {
    const normalized = value.replace(/-/g, "+").replace(/_/g, "/")
    const padded = normalized + "=".repeat((4 - (normalized.length % 4)) % 4)
    return atob(padded)
  } catch {
    return null
  }
}

export const getStoredAccessToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

export const setStoredAccessToken = (token: string): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

export const clearAuthState = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  sessionStorage.clear()
}

export const getTokenClaims = (
  token: string | null = getStoredAccessToken(),
): AuthTokenClaims | null => {
  if (!token) {
    return null
  }

  const parts = token.split(".")
  if (parts.length < 2) {
    return null
  }

  const payload = parseBase64Url(parts[1])
  if (!payload) {
    return null
  }

  try {
    return JSON.parse(payload) as AuthTokenClaims
  } catch {
    return null
  }
}

export const isTokenExpired = (
  token: string | null = getStoredAccessToken(),
): boolean => {
  const claims = getTokenClaims(token)
  if (!claims?.exp) {
    return false
  }

  return claims.exp * 1000 <= Date.now()
}

export const isAuthenticated = (): boolean => {
  const token = getStoredAccessToken()
  if (!token) {
    return false
  }

  return !isTokenExpired(token)
}
